"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedComponents = void 0;
const index_1 = require("../typography/index");
const getSharedComponents = (theme) => ({
    MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: 500,
                textTransform: 'none',
                fontWeight: 600,
                // color: theme.palette.text.secondary,
            },
            contained: {
                boxShadow: '0px',
                // color: theme.palette.common.white,
            },
            startIcon: {
                height: '20px',
                alignItems: 'center',
            },
            endIcon: {
                height: '20px',
                alignItems: 'center',
            },
        },
    },
    MuiButtonBase: {
        defaultProps: {
            disableRipple: true,
        },
    },
    MuiCssBaseline: {
        styleOverrides: {
            '@global': {
                '@font-face': [index_1.openSansRegular, index_1.openSansBoldItalic, index_1.openSansLight, index_1.openSansSemiBold],
            },
        },
    },
    MuiSelect: {
        styleOverrides: {
            select: {
                border: `solid 1px ${theme.palette.grey[300]}`,
                borderRadius: 2,
                paddingLeft: 8,
            },
        },
    },
    MuiTableContainer: {
        styleOverrides: {
            root: {
                border: `1px solid rgba(224, 224, 224, 1)`,
                borderRadius: 5,
            },
        },
    },
    MuiTableCell: {
        styleOverrides: {
            head: {
                color: theme.palette.text.secondary,
                // backgroundColor: '#fafafa',
                // textTransform: 'uppercase',
                // fontSize: theme.typography.caption.fontSize,
            },
            body: {
            // border: `1px solid rgba(224, 224, 224, 1)`,
            },
        },
    },
    MuiTableRow: {
        styleOverrides: {
            root: {
                '&$hover:hover': {
                    backgroundColor: 'rgba(40, 149, 167, 0.04)',
                },
            },
        },
    },
    MuiBackdrop: {
        styleOverrides: {
            root: {
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
            },
        },
    },
    MuiListItem: {
        styleOverrides: {
            root: {
                borderRadius: 12,
                '&$selected': {
                    backgroundColor: 'transparent',
                    color: theme.palette.primary.main,
                },
            },
        },
    },
    MuiListItemIcon: {
        styleOverrides: {
            root: {
                minWidth: theme.spacing(6),
            },
        },
    },
    MuiCardHeader: {
        styleOverrides: {
            title: {
                fontSize: 16,
                fontWeight: 600,
            },
            subheader: {
                fontSize: 14,
            },
            root: {
                paddingBottom: theme.spacing(1),
            },
            action: {
                marginTop: 'auto',
                marginBottom: 'auto',
            },
        },
    },
    MuiCardContent: {
        styleOverrides: {
            root: {
                color: theme.palette.text.secondary,
                paddingTop: 0,
                paddingBottom: 0,
                '&:first-child': {
                    paddingTop: theme.spacing(2),
                },
                '&:last-child': {
                    paddingBottom: theme.spacing(2),
                },
            },
        },
    },
    MuiLink: {
        defaultProps: {
            underline: 'hover',
        },
        styleOverrides: {
            root: {
                fontWeight: 600,
                textDecoration: 'none',
            },
        },
    },
    // MuiExpansionPanelSummary: {
    //   styleOverrides: {
    //   root: {
    //     backgroundColor: '#f9f9f9',
    //   },
    // }
    // },
    MuiTab: {
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontWeight: 600,
            },
        },
    },
    MuiListSubheader: {
        styleOverrides: {
            root: Object.assign({
                color: theme.palette.text.primary,
            }, theme.typography.h6),
        },
    },
    MuiCardActions: {
        styleOverrides: {
            root: {
                justifyContent: 'flex-end',
                padding: theme.spacing(1, 2),
                '&:hover $focusHighlight': {
                    opacity: 0,
                },
            },
            spacing: {
                '& > :not(:first-child)': {
                    marginLeft: theme.spacing(2),
                },
            },
        },
    },
    MuiDialog: {
        styleOverrides: {
            paperWidthXs: {
                maxWidth: 300,
            },
            paperWidthSm: {
                maxWidth: 500,
            },
            paperWidthMd: {
                maxWidth: 800,
            },
            paperWidthLg: {
                maxWidth: 1140,
            },
        },
    },
    MuiDialogTitle: {
        styleOverrides: {
            root: {
                padding: theme.spacing(2),
                paddingRight: theme.spacing(6),
            },
        },
    },
    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: theme.spacing(2),
                background: 'linear-gradient(' +
                    theme.palette.background.paper +
                    ' 1px, hsla(0,0%,100%,0)) 0 0 / 100% 1px, linear-gradient(' +
                    theme.palette.grey[300] +
                    '1px, hsla(0,0%,100%,0)) 0 0 / 100% 1px, linear-gradient(to top, ' +
                    theme.palette.background.paper +
                    +'1px, hsla(0,0%,100%,0)) bottom / 100% 1px, linear-gradient(to top, ' +
                    theme.palette.grey[300] +
                    ', hsla(0,0%,100%,0)) bottom / 100% 1px;',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'local, scroll, local, scroll',
            },
        },
    },
    MuiDialogActions: {
        styleOverrides: {
            root: {
                padding: theme.spacing(2),
            },
            spacing: {
                '& > :not(:first-child)': {
                    marginLeft: theme.spacing(2),
                },
            },
        },
    },
    MuiToggleButton: {
        styleOverrides: {
            root: {
                '&$selected': {
                    backgroundColor: theme.palette.grey[100],
                    color: theme.palette.primary.main,
                },
            },
        },
    },
    MuiFilledInput: {
        styleOverrides: {
            root: {
                border: '1px solid rgb(176, 176, 176)',
                overflow: 'hidden',
                borderRadius: 4,
                backgroundColor: 'transparent',
                transition: theme.transitions.create(['border-color', 'box-shadow']),
                '&:hover': {
                    borderColor: 'rgb(113, 113, 113)',
                    backgroundColor: 'transparent',
                },
                '&$focused': {
                    boxShadow: 'rgb(34, 34, 34) 0 0 0 1px',
                    borderColor: 'rgb(34, 34, 34)',
                    backgroundColor: 'transparent',
                },
                '&$error': {
                    boxShadow: '#B00020 0 0 0 1px',
                    borderColor: '#B00020',
                },
            },
            focused: {},
        },
    },
    MuiFormLabel: {
        styleOverrides: {
            root: {
                color: 'rgb(113, 113, 113)',
                fontSize: theme.typography.body1.fontSize,
                '&$focused': {
                    color: 'rgb(113, 113, 113)',
                },
            },
        },
    },
    MuiFormControlLabel: {
        styleOverrides: {
            label: {
                fontSize: theme.typography.body2.fontSize,
            },
        },
    },
    MuiInputBase: {
        styleOverrides: {
            root: {
                fontSize: theme.typography.body1.fontSize,
                '&::before': {
                    borderBottom: 'none',
                },
                '&::after': {
                    borderBottom: 'none',
                },
            },
        },
    },
    MuiInputLabel: {
        styleOverrides: {
            filled: {
                '&$shrink': {
                    transform: 'translate(12px, 10px) scale(' + 12 / 16 + ')',
                },
            },
        },
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: {
                color: 'rgb(113, 113, 113)',
            },
        },
    },
    MuiChip: {
        styleOverrides: {
            root: {
                height: 24,
            },
        },
    },
    MuiAppBar: {
        styleOverrides: {
            colorDefault: {
                backgroundColor: theme.palette.background.paper,
            },
        },
    },
    MuiDivider: {
        styleOverrides: {
            // @ts-ignore
            root: ({ ownerState }) => ({
                ...(ownerState.className &&
                    ownerState.className.indexOf('thick') > -1 && {
                    '&::before': {
                        borderTopWidth: '0.5rem',
                    },
                    '&::after': {
                        borderTopWidth: '0.5rem',
                    },
                }),
                ...(ownerState.className &&
                    ownerState.className.indexOf('fullWidth') > -1 && {
                    left: 0,
                    position: 'absolute',
                    width: 'inherit',
                }),
            }),
        },
    },
    MuiSlider: {
        styleOverrides: {
            mark: {
                width: 6,
                height: 6,
                borderRadius: 6,
            },
        },
    },
});
exports.getSharedComponents = getSharedComponents;
